module.exports.lovers = {
  vi: {
    title: 'Cặp tình nhân trong Avalon: Tristan, Isolde và Ám sát',
    description:
      'Tristan và Isolde hoạt động thế nào trong Avalon? Tìm hiểu Cặp tình nhân biết gì, vì sao cả hai phải ẩn danh và cách phe Ác Ám sát cặp đôi trên nền tảng này.',
    keywords: ['Cặp tình nhân', 'Tristan', 'Isolde', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Amantes em Avalon: Tristan, Isolde e assassinato',
    description:
      'Como Tristan e Isolde funcionam em Avalon? Saiba o que os Amantes conhecem e por que o mal precisa identificar ambos para assassinar a dupla.',
    keywords: ['Amantes', 'Tristão', 'Isolda', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Lovers in Avalon: Tristan, Isolde & Assassination',
    description:
      'How do Tristan and Isolde work in Avalon? Learn what the Lovers know, why both must stay hidden and how evil can assassinate the pair on this platform.',
    keywords: ['Lovers', 'Tristan', 'Isolde', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Любовники в Авалоне: Тристан, Изольда и убийство',
    description:
      'Как играют Тристан и Изольда в Авалоне? Взаимное знание ролей, скрытая пара и условие победы зла при убийстве обоих Любовников.',
    keywords: ['Любовники', 'Тристан', 'Изольда', 'Роль', 'Правила', 'Советы'],
  },
  'zh-CN': {
    title: '阿瓦隆恋人：特里斯坦、伊索德与刺杀',
    description:
      '阿瓦隆恋人怎么玩？了解特里斯坦与伊索德互知身份的能力、隐藏关系的技巧，以及刺杀恋人必须猜中两人的规则。',
    keywords: ['恋人', '特里斯坦', '伊索尔德', '角色', '规则', '提示'],
  },
  'zh-TW': {
    title: '阿瓦隆戀人：特里斯坦、伊索德與刺殺',
    description:
      '阿瓦隆戀人怎麼玩？了解特里斯坦與伊索德互知身分的能力、隱藏關係的技巧，以及刺殺戀人必須猜中兩人的規則。',
    keywords: ['戀人', '特里斯坦', '伊索爾德', '角色', '規則', '提示'],
  },
  es: {
    title: 'Amantes en Avalon: Tristán, Isolda y asesinato',
    description:
      '¿Cómo funcionan Tristán e Isolda en Avalon? Descubre qué saben los Amantes y por qué el mal debe identificar a ambos para asesinar a la pareja.',
    keywords: ['Amantes', 'Tristán', 'Isolda', 'Rol', 'Reglas', 'Consejos'],
  },
};
